/**
 * Maps human-readable keys to Framer XLIFF translation unit IDs.
 * Used by the contact page to look up translations from messages/{locale}.json.
 *
 * To find new keys: search messages/en.json for the English text,
 * then add the Framer ID here.
 */
export const contactKeys = {
  // Hero
  pageLabel: "pageLabel", // "CONTACT"
  heading: "heading", // "Contact us"
  subtitle: "subtitle", // "Have a question? We'd love to hear from you."

  // Contact methods
  emailTitle: "emailTitle", // "Email us"
  chatTitle: "chatTitle", // "Chat with us"
  callTitle: "callTitle", // "Call us"
  calendarTitle: "calendarTitle", // "Book a discovery call"
  locationsTitle: "locationsTitle", // "Locations"
  followTitle: "followTitle", // "Follow us"

  // Reply note
  replyNote: "replyNote", // "Usually replies in minutes"

  // Contact method actions
  chatAction: "contact_chatAction", // "Start a WhatsApp chat"
  calendarAction: "contact_calendarAction", // "Book your call"
  locationsAction: "contact_locationsAction", // "Find your nearest clinic"
  linkedinAction: "contact_linkedinAction", // "Ahead Health on LinkedIn"

  // Intent routing (new hero)
  intentHeading: "contact_intentHeading", // "How would you like to reach us?"
  bookCallDesc: "contact_bookCallDesc", // "Free 15-minute call with our team"
  chatNowAction: "contact_chatNowAction", // "Start the conversation" (Intercom)
  chatDesc: "contact_chatDesc", // "Usually replies in minutes"
  whatsappTitle: "contact_whatsappTitle", // "WhatsApp"
  whatsappDesc: "contact_whatsappDesc", // "Message us on WhatsApp"
  phoneHours: "contact_phoneHours", // "Mon–Fri, 09:00–18:00 CET"
  emailSectionHeading: "contact_emailSectionHeading", // "Prefer email?"
  emailSectionSubtitle: "contact_emailSectionSubtitle", // "Send us a message and we'll respond to your inbox."
  privacyNote: "contact_privacyNote", // "Encrypted & compliant with Swiss data protection law and GDPR. We never share your details."

  // Form section
  formHeadingText: "contact_formHeadingText", // "Send us a message"
  messageSentHeading: "contact_messageSentHeading", // "Message sent"
  messageSentText: "contact_messageSentText", // "Thanks for reaching out..."
  emailLabel: "contact_emailLabel", // "Email"
  sendButton: "contact_sendButton", // "Send"

  // Form errors
  formValidationError: "contact_formValidationError", // "Please check your details and try again."
  formRateLimitError: "contact_formRateLimitError", // "Too many attempts. Please try again in a minute."
  formSendError: "contact_formSendError", // "Something went wrong. Please email us at get@aheadhealth.com."

  // Form labels
  firstNameLabel: "firstNameLabel", // "First name *"
  firstNamePlaceholder: "firstNamePlaceholder", // "Enter first name"
  lastNameLabel: "lastNameLabel", // "Last name *"
  lastNamePlaceholder: "lastNamePlaceholder", // "Enter last name"
  emailPlaceholder: "emailPlaceholder", // "Enter email"
  messageLabel: "messageLabel", // "Ask us anything *"
  messagePlaceholder: "messagePlaceholder", // "Enter message..."

  // FAQ section on contact page
  faqHeading: "faqHeading", // "Frequently asked questions" (HTML stripped at load)
  faqViewAll: "contact_faqViewAll", // "Read all FAQs" (link to /faq)
  faq1_q: "contact_faq1_q", // "Do I need a referral for an Ahead scan?"
  faq1_a: "contact_faq1_a", // "No, you do not need a referral..."
  faq2_q: "contact_faq2_q", // "Does Ahead screening involve ionising radiation?"
  faq2_a: "contact_faq2_a", // "No. It is based on MRI..."
  faq3_q: "contact_faq3_q", // "Can I eat or drink on the day of the exam?"
  faq3_a: "contact_faq3_a", // "In most cases, you should fast..."
  faq4_q: "contact_faq4_q", // "When will I get my results?"
  faq4_a: "contact_faq4_a", // "Your results will typically be available..."
  faq5_q: "contact_faq5_q", // "Does my health insurance cover the costs?"
  faq5_a: "contact_faq5_a", // "Supplementary health insurers..."
  faq6_q: "contact_faq6_q", // "Do you work with employer programmes?"
  faq6_a: "contact_faq6_a", // "Some employers offer health programs..."

  // Locations section
  locationsHeading: "locationsHeading", // "Locations"
  locationsDescription: "locationsDescription", // "Our team carefully screens each partner clinic..."
  fullBodyCheckup: "fullBodyCheckup", // "Full-body checkup"
  bloodTest: "bloodTest", // "Standalone blood test"
  viewAllLocations: "contact_viewAllLocations", // "View all locations"

  // Head office
  headOfficeTitle: "headOfficeTitle", // "Ahead Health head office: Zürich"
  headOfficeAddress: "headOfficeAddress", // "Uraniastrasse 31, 8001 Zürich, Switzerland"

  // Bottom CTA
  ctaHeading: "contact_ctaHeading", // "Take the first step towards a healthier you"
  ctaBookButton: "contact_ctaBookButton", // "Book check-up"
  ctaTalkButton: "contact_ctaTalkButton", // "Talk to our team"
} as const
